import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ChartNoAxesColumn, ChevronDown, Plus, Search } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";

type CreateMenuProps = {
  onTrackKpi: () => void;
  onRunAnalysis: () => void;
};

/**
 * The page's two ways to start something: a standing KPI re-run on a
 * schedule, or a one-off question. Both open in the Ask sidebar.
 */
const CreateMenu = ({ onTrackKpi, onRunAnalysis }: CreateMenuProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: "watchlist" });
  const items = [
    {
      key: "kpi",
      Icon: ChartNoAxesColumn,
      label: t("track_kpi"),
      hint: t("track_kpi_hint"),
      run: onTrackKpi,
    },
    {
      key: "analysis",
      Icon: Search,
      label: t("run_analysis"),
      hint: t("run_analysis_hint"),
      run: onRunAnalysis,
    },
  ];

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        data-tour="watchlist-setup"
        className="inline-flex h-[38px] shrink-0 items-center gap-2 rounded-lg bg-primary px-3 text-sm font-medium text-on-accent outline-none transition hover:bg-primary/90 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface"
      >
        <Plus size={16} aria-hidden="true" />
        {t("create")}
        <ChevronDown size={14} aria-hidden="true" />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align="end" sideOffset={6} className="dropdown-menu w-72">
          {items.map(({ key, Icon, label, hint, run }) => (
            <DropdownMenu.Item
              key={key}
              onSelect={run}
              className="dropdown-option items-start gap-3"
            >
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
                <Icon size={16} aria-hidden="true" />
              </span>
              <span className="min-w-0">
                <span className="block font-medium text-text">{label}</span>
                <span className="block text-xs text-text-dim">{hint}</span>
              </span>
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default CreateMenu;
